import LocationFileOrUpload from "./location-file-or-upload";
import { LocationFileWrap } from "./file-wrap";

export {
    LocationFileWrap
}

export default LocationFileOrUpload;